(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var config = window.CrownThemeConfig || {};
  var serviceBase = String(config.schoolServiceBase || '').replace(/\/$/, '');

  function route(path) { return String(root).replace(/\/?$/, '/') + String(path).replace(/^\//, ''); }
  function service(path) { return serviceBase ? serviceBase + path : path; }
  function emitToast(message) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message; toast.classList.add('is-visible');
    window.clearTimeout(emitToast.timer); emitToast.timer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = String(count); });
    document.querySelectorAll('[data-cart-link]').forEach(function (node) { node.setAttribute('aria-label', 'Cart (' + count + ')'); });
  }
  function fetchCart() {
    return fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable'); return response.json();
    }).then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  function initCartForm(form) {
    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-cart-line-key]'));
    var checkoutButton = form.querySelector('[name="checkout"]');
    var status = form.querySelector('[data-cart-update-status]');
    var updateTimer;
    if (!inputs.length || !status) return;

    function setPending(pending) {
      form.setAttribute('aria-busy', String(pending));
      if (checkoutButton) checkoutButton.disabled = pending;
    }

    function updateCart() {
      var updates = {};
      inputs.forEach(function (input) {
        var quantity = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
        input.value = String(quantity);
        updates[input.dataset.cartLineKey] = quantity;
      });
      setPending(true);
      status.textContent = 'Updating cart…';
      fetch(route('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      }).then(function (cart) {
        updateCartCount(cart.item_count);
        status.textContent = 'Cart updated.';
        window.location.reload();
      }).catch(function () {
        setPending(false);
        status.textContent = 'We could not update your cart. Please try changing the quantity again.';
      });
    }

    function scheduleUpdate() {
      window.clearTimeout(updateTimer);
      setPending(true);
      status.textContent = 'Updating cart…';
      updateTimer = window.setTimeout(updateCart, 450);
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', scheduleUpdate);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          input.blur();
          scheduleUpdate();
        }
      });
    });
  }

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('primary-nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open); document.body.classList.toggle('nav-open', open);
    });
  }

  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-slide]'));
    var index = 0; var timer;
    function show(next) { index = (next + slides.length) % slides.length; slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); }); }
    function start() { if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; window.clearInterval(timer); timer = window.setInterval(function () { show(index + 1); }, 5000); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) window.clearInterval(timer); else start(); }); start();
  });

  document.querySelectorAll('[data-compare]').forEach(function (compare) {
    var range = compare.querySelector('[data-compare-range]'); if (!range) return;
    function render() {
      compare.style.setProperty('--pos', range.value + '%');
      range.setAttribute('aria-valuetext', Math.round(Number(range.value)) + '% after image shown');
    }
    range.addEventListener('input', render); render();
  });

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-in'); observer.unobserve(entry.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;
  document.querySelectorAll('.reveal').forEach(function (node) { if (observer) observer.observe(node); else node.classList.add('is-in'); });

  document.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
    button.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main], .gallery__main img');
      if (main && button.dataset.imageUrl) main.src = button.dataset.imageUrl;
    });
  });

  var offer = document.querySelector('[data-welcome-offer]');
  if (offer) {
    var close = offer.querySelector('[data-welcome-close]');
    var success = offer.querySelector('.welcome-offer__success');
    var stateKey = 'crown-welcome-offer-v2';
    if (close) close.addEventListener('click', function () { if (offer.open) offer.close(); try { localStorage.setItem(stateKey, String(Date.now())); } catch (_) {} });
    var lastSeen = 0; try { lastSeen = Number(localStorage.getItem(stateKey) || 0); } catch (_) {}
    if (success) { window.setTimeout(function () { if (!offer.open) offer.showModal(); }, 100); }
    else if (document.body.classList.contains('template-index') && Date.now() - lastSeen > 7 * 86400000) {
      window.setTimeout(function () { if (!offer.open) offer.showModal(); }, 1200);
    }
  }

  var fundraisingPage = document.querySelector('[data-fundraising-page]');
  if (fundraisingPage) initFundraising(fundraisingPage);

  var cartForm = document.getElementById('cart');
  if (cartForm) initCartForm(cartForm);

  function initFundraising(page) {
    var picker = page.querySelector('[data-school-picker]');
    var input = picker.querySelector('[data-school-input]');
    var options = picker.querySelector('[data-school-options]');
    var status = picker.querySelector('[data-school-status]');
    var bridgeStatus = picker.querySelector('[data-school-bridge-status]');
    var active = picker.querySelector('[data-school-active]');
    var activeName = picker.querySelector('[data-active-school-name]');
    var inactive = picker.querySelector('[data-school-inactive]');
    var inactiveName = picker.querySelector('[data-inactive-school-name]');
    var shopButton = picker.querySelector('[data-school-shop]');
    var shareButton = picker.querySelector('[data-share-school]');
    var registrationSchoolInput = page.querySelector('#school-name');
    var addForms = Array.prototype.slice.call(page.querySelectorAll('[data-fundraising-add]'));
    var schools = []; var selected = null; var searchTimer; var focused = -1; var registrationPrefill = ''; var storageKey = 'crown-fundraising-school-v2';

    function clean(value) { return String(value || '').trim(); }
    function isParticipatingSchool(school) {
      return Boolean(school && school.participating !== false
        && clean(school.id) && clean(school.name) && clean(school.fundraising_code));
    }
    function label(school) { return school.location ? school.name + ' — ' + school.location : school.name; }
    function escapeHtml(value) { return String(value).replace(/[&<>\"]/g, function (char) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[char]; }); }
    function closeOptions() { options.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); focused = -1; }
    function renderOptions(open) {
      options.innerHTML = schools.map(function (school, index) {
        var detail = [school.location, school.region].filter(Boolean).join(' · ');
        return '<button type="button" role="option" id="school-option-' + index + '" data-school-index="' + index + '" aria-selected="false"><span><strong>' + escapeHtml(school.name) + '</strong>' + (detail ? '<small>' + escapeHtml(detail) + '</small>' : '') + '</span><em>' + (school.participating === false ? 'Needs registration' : 'Fundraiser active') + '</em></button>';
      }).join('');
      options.hidden = !open || !schools.length; input.setAttribute('aria-expanded', String(!options.hidden)); focused = -1;
    }
    function focusOption(next) {
      var items = Array.prototype.slice.call(options.querySelectorAll('[role="option"]')); if (!items.length) return;
      focused = (next + items.length) % items.length;
      items.forEach(function (item, index) { item.setAttribute('aria-selected', String(index === focused)); });
      input.setAttribute('aria-activedescendant', items[focused].id); items[focused].scrollIntoView({ block: 'nearest' });
    }
    function setButtons(school) {
      addForms.forEach(function (form) { var button = form.querySelector('button'); button.disabled = !school; button.textContent = school ? 'Add for ' + school.name : 'Choose a participating school'; });
    }
    function setShopButton(school) {
      var enabled = Boolean(school);
      shopButton.classList.toggle('is-disabled', !enabled);
      shopButton.setAttribute('aria-disabled', String(!enabled));
    }
    function applySchool(school) {
      selected = isParticipatingSchool(school) ? school : null;
      active.hidden = !selected; activeName.textContent = selected ? selected.name : '';
      inactive.hidden = !school || Boolean(selected);
      inactiveName.textContent = !selected && school ? school.name : 'This school';
      setButtons(selected); setShopButton(selected); bridgeStatus.textContent = '';
      if (!selected && school && registrationSchoolInput && (!clean(registrationSchoolInput.value) || registrationSchoolInput.value === registrationPrefill)) {
        registrationSchoolInput.value = school.name;
        registrationPrefill = school.name;
      } else if (selected && registrationSchoolInput && registrationSchoolInput.value === registrationPrefill) {
        registrationSchoolInput.value = '';
        registrationPrefill = '';
      }
      try {
        if (selected) localStorage.setItem(storageKey, selected.fundraising_code);
        else localStorage.removeItem(storageKey);
      } catch (_) {}
      document.dispatchEvent(new CustomEvent('crown:fundraising-school', { detail: { school: selected } }));
      if (!selected && school) status.textContent = 'This school must register before purchases can support it.';
      else if (selected) status.textContent = 'This school will stay connected through Shopify cart and checkout.';
    }
    function choose(school) { input.value = label(school); closeOptions(); applySchool(school); }

    function loadParticipating() {
      return fetch(service('/api/fundraising/schools'), { headers: { Accept: 'application/json' } }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); }).then(function (payload) {
        schools = Array.isArray(payload.schools) ? payload.schools.map(function (school) { return Object.assign({ participating: true }, school); }) : [];
        var params = new URLSearchParams(location.search); var code = params.get('school');
        var linked = code && schools.find(function (school) { return clean(school.fundraising_code).toLowerCase() === clean(code).toLowerCase(); });
        if (linked) choose(linked);
        else {
          renderOptions(false); setButtons(null);
          if (code) {
            applySchool(null);
            status.textContent = 'This fundraiser link is no longer active. Choose another school or register your school below.';
          }
        }
      }).catch(function () { status.textContent = 'Participating schools are temporarily unavailable. Please try again shortly.'; });
    }
    loadParticipating();

    input.addEventListener('input', function () {
      if (selected || !inactive.hidden) applySchool(null); else { setButtons(null); setShopButton(null); active.hidden = true; }
      window.clearTimeout(searchTimer); var query = clean(input.value);
      if (query.length < 2) { closeOptions(); status.textContent = 'Enter at least two letters to search the New Zealand school register.'; return; }
      status.textContent = 'Searching the New Zealand school register…';
      searchTimer = window.setTimeout(function () {
        fetch(service('/api/fundraising/directory?q=' + encodeURIComponent(query)), { headers: { Accept: 'application/json' } }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); }).then(function (payload) {
          if (clean(input.value) !== query) return; schools = Array.isArray(payload.schools) ? payload.schools : []; renderOptions(true); status.textContent = schools.length ? 'Choose your school from the matches below.' : 'No open New Zealand school matched that name.';
        }).catch(function () { closeOptions(); status.textContent = 'School search is temporarily unavailable. Please try again shortly.'; });
      }, 220);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') { event.preventDefault(); focusOption(focused + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); focusOption(focused - 1); }
      else if (event.key === 'Enter' && focused >= 0) { event.preventDefault(); choose(schools[focused]); }
      else if (event.key === 'Escape') closeOptions();
    });
    options.addEventListener('mousedown', function (event) { event.preventDefault(); });
    options.addEventListener('click', function (event) { var option = event.target.closest('[data-school-index]'); if (option) choose(schools[Number(option.dataset.schoolIndex)]); });
    shopButton.addEventListener('click', function (event) {
      if (selected) return;
      event.preventDefault();
      status.textContent = 'Choose a participating school before shopping the fundraiser.';
      input.focus();
    });

    document.addEventListener('crown:shopify-fundraising-synced', function () { bridgeStatus.textContent = selected ? 'School saved to your Shopify cart.' : ''; });
    document.addEventListener('crown:shopify-fundraising-error', function () { bridgeStatus.textContent = selected ? 'Your school could not be saved. Please try selecting it again.' : ''; });
    addForms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault(); if (!selected) { input.focus(); return; }
        var button = form.querySelector('button'); button.disabled = true; button.textContent = 'Adding…';
        var bridge = window.CrownStandardShopifyFundraising;
        var synced = bridge ? bridge.syncSchool(selected) : Promise.reject(new Error('School connection unavailable'));
        synced.then(function () {
          return fetch(route('cart/add.js'), { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] }) });
        }).then(function (response) { if (!response.ok) throw new Error('This product could not be added.'); return response.json(); }).then(function () { return fetchCart(); }).then(function () { emitToast('Added for ' + selected.name); button.textContent = 'Added to cart'; window.setTimeout(function () { button.disabled = false; button.textContent = 'Add for ' + selected.name; }, 1400); }).catch(function (error) { bridgeStatus.textContent = error.message || 'Please try again.'; button.disabled = false; button.textContent = 'Add for ' + selected.name; });
      });
    });
    if (shareButton) shareButton.addEventListener('click', function () {
      if (!selected) return; var url = new URL(location.href); url.search = ''; url.hash = ''; url.searchParams.set('school', selected.fundraising_code);
      var data = { title: selected.name + ' fundraiser', text: 'Support ' + selected.name + ' with Crown Standard.', url: url.toString() };
      if (navigator.share) navigator.share(data).catch(function () {}); else if (navigator.clipboard) navigator.clipboard.writeText(url.toString()).then(function () { emitToast('Fundraiser link copied'); });
    });

    var slides = Array.prototype.slice.call(page.querySelectorAll('[data-fund-hero-slide]')); var slideIndex = 0;
    if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) window.setInterval(function () { slideIndex = (slideIndex + 1) % slides.length; slides.forEach(function (slide, index) { slide.classList.toggle('is-active', index === slideIndex); }); }, 5000);

    var registrationForm = page.querySelector('#school-registration-form');
    if (registrationForm) {
      var registrationStatus = registrationForm.querySelector('[data-registration-status]');
      var registrationButton = registrationForm.querySelector('[data-registration-submit]');
      registrationForm.addEventListener('submit', function (event) {
        if (registrationForm.dataset.nativeSubmitting === 'true') return;
        event.preventDefault();
        var formData = new FormData(registrationForm);
        registrationButton.disabled = true;
        registrationButton.textContent = 'Saving…';
        registrationStatus.hidden = false;
        registrationStatus.className = 'form-status';
        registrationStatus.textContent = 'Saving your school registration securely…';
        fetch(service('/api/fundraising/registrations'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            schoolName: formData.get('contact[School name]'),
            contactName: formData.get('contact[name]'),
            email: formData.get('contact[email]'),
            phone: formData.get('contact[phone]'),
            role: formData.get('contact[Role at school or PTA]'),
            website: formData.get('website')
          })
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) throw new Error(payload.error || 'Your school registration could not be saved.');
            return payload;
          });
        }).then(function (payload) {
          if (payload.discarded) {
            registrationForm.reset();
            registrationStatus.className = 'form-status form-success';
            registrationStatus.textContent = 'Thank you. Your registration has been received.';
            registrationButton.disabled = false;
            registrationButton.textContent = 'Register your school';
            return;
          }
          if (payload.created) {
            registrationStatus.textContent = 'Saved. Sending your registration to Crown Standard…';
            registrationForm.dataset.nativeSubmitting = 'true';
            HTMLFormElement.prototype.submit.call(registrationForm);
            return;
          }
          registrationStatus.className = 'form-status form-success';
          registrationStatus.textContent = payload.message || 'We already have this registration and have updated the contact details.';
          registrationButton.disabled = false;
          registrationButton.textContent = 'Registration received';
        }).catch(function (error) {
          registrationStatus.className = 'form-status form-errors';
          registrationStatus.textContent = error.message || 'Your school registration could not be saved. Please try again.';
          registrationButton.disabled = false;
          registrationButton.textContent = 'Try again';
        });
      });
    }

  }

  fetchCart().catch(function () {});
}());
